import React, { Fragment } from "react";
import { DropdownItem } from "reactstrap";

const QuickActions = ({
  setDriverObj,
  element,
  toggleAssignBookingModal,
  toggleLocateDriverModal,
  toggleNotifyDriverModal,
  toggleResetDriverModal,
  toggleBlockDriverModal,
}) => {
  return (
    <Fragment>
      <DropdownItem
        className="border-0"
        key={"row-edit"}
        onClick={() => {
          setDriverObj(element);
          toggleAssignBookingModal();
        }}
      >
        <i className="fa fa-user-plus"></i> Assign Trip
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-cancel"}
        onClick={() => {
          setDriverObj(element);
          toggleLocateDriverModal();
        }}
      >
        <i className="fa fa-map-marker"></i> Locate
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-notify"}
        onClick={() => {
          setDriverObj(element);
          toggleNotifyDriverModal();
        }}
      >
        <i className="fa fa-bell"></i> Notify
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-block"}
        onClick={() => {
          setDriverObj(element);
          toggleBlockDriverModal();
        }}
      >
        <i className="fa fa-ban"></i> Block
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-reset"}
        onClick={() => {
          setDriverObj(element);
          toggleResetDriverModal();
        }}
      >
        <i className="fa fa-refresh"></i> Reset login
      </DropdownItem>
    </Fragment>
  );
};

export default QuickActions;
